import React from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import {DangerAlert} from '@modifi/ui'

const propTypes = {
  params: PropTypes.shape({
    error: PropTypes.string.isRequired,
  }).isRequired,
}

const defaultProps = {
  params: undefined as null | undefined,
}

type ErrorDialogProps = InferPropTypes<typeof propTypes, typeof defaultProps>

const SubmitProgressDialog: React.FC<ErrorDialogProps> = ({params}) => (
  <p>{params?.error && <DangerAlert>{params.error}</DangerAlert>}</p>
)

export default SubmitProgressDialog
